import React from 'react';

import InviteDialog from './InviteDialog';

//axios
import axios from 'axios';
import axiosUrl from '../../axios/url';



export default function Organization(param) {

    const [members, setMembers]  = React.useState([]);                  // 구성원 목록

    // 멤버 목록 조회
    async function getMemberList(){
        var url = axiosUrl.organization;
        await axios.get(url,{
            params:{
                accounts :{
                    //size: itemsCountPerPage,
                    sort: 'id',
                    order:'desc',
                    //page: activePage
                }
            }
        })
        .then( res => {
            
            const xitemrange = res.headers['x-item-range'].replace('items ','').split('/');
            //setTotalItemsCount(xitemrange[1]);

            const arr = res.data[0].accounts;
            if(arr.length > 0) {
                if(JSON.stringify(members) !== JSON.stringify(arr)) 
                    setMembers(arr);
            }
        })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] Organization - ' + e);
        });

    }


    async function goInviteAgain(email){
        if(!window.confirm(email + '님에게 초대장을 다시 보내시겠습니까?')) return;
        
        await axios.post(axiosUrl.invite ,{
            username: email,
        })
        .then(function (res){
            alert('초대장을 보냈습니다.');
            window.location.reload();
        })
        .catch(function (e) {
            alert(e.response.data.error.message);
        });
    }

        // 해당 콘텐츠 삭제
    async function deleteMember(email){
        if(!window.confirm('해당 멤버를 삭제하시겠습니까?')) return;

        var url = axiosUrl.organization_delete + '/' + email;
        await axios.delete(url)
        .then(function (response){ 
            alert('멤버가 삭제되었습니다.');
            getMemberList(); 
        })
        .catch(function (e) {
            alert('멤버 삭제에 실패하였습니다. 다시 시도하세요.');
            
            console.error('[MEDIEX_CMS_2019_ERROR] Organization.deleteMember - ' + e.response.data.error.message);
        });
    
    }

    React.useEffect(() => {
       getMemberList();
    });


    return(
        <div>
            <div className="content-wrapper">
            <section className="content-header">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1>조직</h1>
                    </div>
                </div>
            </div>
            </section>

            <section className="content">

            <div className="card">
                <div className="card-header contentColor">
                <h4 className="card-title">멤버</h4>

                <div className="card-header-image">
                <a className="cursor-pointer text-primary" data-toggle="modal" data-target="#InviteDialog" title="새 멤버 초대하기"><i className="fas fa-user-plus"/> 새 멤버 초대하기</a>
                </div>
                </div>
                <div className="card-body p-0">
                <table className="table table-striped projects table-hover">
                    <thead>
                        <tr>
                            <th >
                                #
                            </th>
                            <th >
                                이메일 주소
                            </th>
                            <th  className="text-center">
                                상태
                            </th>
                            <th  className="text-center">
                                삭제
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                            members.map( (value, i) =>
                                <tr key={i}>
                                    <td> #</td>
                                    
                                    {value.accountLocked && <td><i className='fas fa-user-alt-slash text-danger'/>  <a >{value.username}</a>  <a className="cursor-pointer text-success" title="다시 초대하기"  onClick={() => goInviteAgain(value.username)} ><i className="far fa-envelope"/></a></td> }
                                    {!value.accountLocked && <td><i className='fas fa-user text-primary'/>  <a className="font-weight-bold">{value.username}</a></td> }

                                    {value.accountLocked && <td className="text-center"><button className="btn btn-danger btn-sm" >비활성</button></td> }
                                    {!value.accountLocked && <td className="text-center"><button className="btn btn-primary btn-sm" >활성</button> </td> }

                                    <td className="project-actions text-center ">
                                        <h4><i  onClick={() => deleteMember(value.username)} className="fas fa-trash-alt text-black-50 cursor-pointer" /> </h4>
                                    </td>
                                    
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                </div>
            </div>

            </section>

        </div>
        <InviteDialog/>
        </div>
        


    );
}